<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="form!">
    <h2 class="text-base font-bold text-font-primary">Affected Items</h2>
    <div class="mt-4 flex flex-col gap-4">
        <sag-ui-select
            [required]="true"
            label="Select your Item or Quantity Discrepancy"
            placeholder="Discrepancy"
            formControlName="issueType"
            class="max-w-input"
        >
            @for (item of issueTypes | keyvalue; track $index) {
            <sag-ui-option [value]="item.value">{{ item.value }}</sag-ui-option>
            }
        </sag-ui-select>
        @if (hasReceivedUnorderedItem) {
        <sag-ui-input
            label="Confirm SMN which was received but not ordered"
            placeholder="Received Unordered Item"
            formControlName="unorderedItemSmn"
            class="max-w-input"
        ></sag-ui-input>
        <sag-ui-input
            label="Confirm quantity which was received but not ordered"
            placeholder="e.g. 5"
            formControlName="unorderedItemQuantity"
            class="max-w-input"
            type="number"
        ></sag-ui-input>
        } @else {
        <app-order-line-table
            [selected]="lineItems"
            [disabled]="disabled"
            (selectionChange)="handleSelectionChange($event)"
            currency="USD"
        ></app-order-line-table>
        } @if (!disabled) {
        <div class="flex items-center justify-end max-w-[1400px]">
            <sag-ui-button [disabled]="!valid || confirmed" (click)="setConfirmed()" size="sm">{{
                confirmed ? 'Confirmed' : 'Confirm'
            }}</sag-ui-button>
        </div>
        }
    </div>
</section>
